export default [
  {
    path: '/estimate-spring/index',
    name: 'index',
    component: () => import('@/views/estimate-spring/index'),
    meta: {
      title: '2024广东春季高考估分系统'
    }
  },{
    path: '/estimate-spring/page',
    name: 'page',
    component: () => import('@/views/estimate-spring/page'),
    meta: {
      title: '2024广东春季高考估分系统'
    }
  },{
    path: '/estimate-spring/rank',
    name: 'rank',
    component: () => import('@/views/estimate-spring/rank'),
    meta: {
      title: '2024广东春季高考估分系统'
    }
  },{
    path: '/estimate-spring/paper',
    name: 'paper',
    component: () => import('@/views/estimate-spring/paper'),
    meta: {
      title: '2024广东春季高考估分系统'
    }
  },{
    path: '/estimate-spring/result',
    name: 'result',
    component: () => import('@/views/estimate-spring/result'),
    meta: {
      title: '2024广东春季高考估分系统'
    }
  },{
    path: '/estimate-spring/report',
    name: 'report',
    component: () => import('@/views/estimate-spring/report'),
    meta: {
      title: '2024广东春季高考估分系统'
    }
  },
]